<template>
	<my-dialog :visible.sync="showDialog" :title="title" dialog-type="form" :close-on-click-modal="false" width="80%" @close="closeDialog">
		<el-form :inline="true" :model="formInline" class="user-search">
			<el-form-item label="提成内容：">
				<el-input clearable v-model="formInline.content" placeholder="请输入提成内容" size="small"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button size="small" type="primary" class="el-icon-search" @click="getListData()">搜索</el-button>
			</el-form-item>
		</el-form>
		<el-table :cell-class-name="$moneyCellClass"
			v-loading="loading"
			:data="listData"
			border
			stripe
			style="width: 100%; border-radius: 10px"
			element-loading-text="加载中..."
			:header-cell-style="{ textAlign: 'center', backgroundColor: '#b3e0ff' }"
			:cell-style="{ textAlign: 'center' }"
		>
			<el-table-column prop="rowNumber" label="序号" width="60"></el-table-column>
			<el-table-column prop="storeName" label="门店名称" width="90"></el-table-column>
			<el-table-column label="提成月份" width="110">
				<template #default="scope">{{ scope.row.year }}年{{ scope.row.month }}月</template>
			</el-table-column>
			<el-table-column prop="employeeName" label="员工" width="90"></el-table-column>
			<el-table-column prop="typeStr" label="提成类型" width="120"></el-table-column>
			<el-table-column prop="money" label="提成金额(元)" width="120"></el-table-column>
			<el-table-column prop="content" label="提成内容" :show-overflow-tooltip="true"></el-table-column>
			<el-table-column prop="isGrant" label="是否发放" width="100">
				<template #default="scope">
					<el-tag :type="scope.row.isGrant == 1 ? 'success' : 'danger'">{{ scope.row.isGrant == 1 ? "已发放" : "未发放" }}</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="grantUserName" label="发放人" width="90"></el-table-column>
			<el-table-column label="发放月份" width="120">
				<template #default="scope">{{ scope.row.grantYear }}年{{ scope.row.grantMonth }}月</template>
			</el-table-column>
			<el-table-column prop="creator" label="经办人" width="90"></el-table-column>
			<el-table-column prop="createTime" label="经办时间" width="170"></el-table-column>
		</el-table>

		<!-- 分页组件 -->
		<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
		<template #footer>
			<div class="dialog-footer">
				<el-button size="small" @click="closeDialog">关闭</el-button>
			</div>
		</template>
	</my-dialog>
</template>

<script>
import { GetCommissionEmployeePageList } from "@/api/salaryApi.js";
import { GetEnumConfigListByCode } from "@/api/enumApi.js";
export default {
	data() {
		return {
			loading: false, // 显示加载
			listData: [],
			formInline: {
				keyId: "",
				type: 0,
				grantYear: 0,
				grantMonth: 0,
				employeeKeyId: "",
				content: ""
			},
			showDialog: false,
			pageShow: true,
			pageparm: {
				pageIndex: 1,
				pageSize: 10,
				total: 0
			},
			title: "员工月提成记录"
		};
	},
	// 注册组件
	components: {},
	created() {
		this.GetEnumConfigListByCode();
	},
	computed: {},
	methods: {
		showCommissionReord(val, type) {
			// 清空上一次的数据，显示加载中
			this.resetData();
			this.loading = true;
			this.formInline.employeeKeyId = val.userKeyId;
			this.formInline.grantYear = val.year;
			this.formInline.grantMonth = val.month;
			this.formInline.type = type;
			var typeStr = "";
			switch (type) {
				case 1:
					typeStr = "充卡提成";
					break;
				case 2:
					typeStr = "销售提成";
					break;
				case 3:
					typeStr = "充卡电话提成";
					break;
				case 4:
					typeStr = "跑单会员提成";
					break;
				case 5:
					typeStr = "进店成交提成";
					break;
				case 6:
					typeStr = "销售电话提成";
					break;
			}
			this.title = "【" + val.userInfo.chName + "】" + val.year + "年" + val.month + "月【" + typeStr + "】发放记录";
			this.showDialog = true;
			this.getListData();
		},
		// 重置展示数据（打开弹窗/切换数据时清空旧内容）
		resetData() {
			this.listData = [];
		},
		// 获取列表
		getListData() {
			this.loading = true;
			GetCommissionEmployeePageList(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						this.loading = false;
						this.listData = res.data;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				})
				.finally(() => {
					this.loading = false;
				});
		},
		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},
		// 关闭弹窗
		closeDialog() {
			this.showDialog = false;
		},
		//获取状态信息
		GetEnumConfigListByCode() {
			const paramer = {
				code: "CommissionType"
			};
			GetEnumConfigListByCode(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.typeList = [];
						res.data.forEach((item) => {
							this.typeList.push({
								keyId: parseInt(item.code),
								value: item.name
							});
						});
						this.typeList.unshift({
							keyId: 0,
							value: "全部"
						});
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取状态信息失败!");
				});
		}
	}
};
</script>

<style scoped></style>
